module.exports = __webpack_public_path__ + "static/img/Connor-Watson.a1af9ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Connor-Watson.jpg
// module id = WdF6
// module chunks = 0